import React, { useEffect, useState } from "react";
import { Button, Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Menu, MenuItem } from "@szhsin/react-menu";

import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import { ReactComponent as MoreHorizIcon } from "../../icons/MoreHoriz24.svg";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import SelectStudentsDialog from "../../components/faculty/SelectStudentsDialog";
import SelectStudentListsDialog from "../../components/faculty/SelectStudentListsDialog";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import AttendanceStatus from "../../components/faculty/AttendanceStatus";
import ActivityDetails from "../../components/faculty/ActivityDetails";
import AttendeeDetailsDialog from "../../components/faculty/AttendeeDetailsDialog";
import AddStudentResultDialog from "../../components/faculty/AddStudentResultDialog";
import InfoIcon from "../../components/InfoIcon.jsx";
import SearchBar from "../../components/faculty/SearchBar";

import isEmpty from "lodash-es/isEmpty";
import { isStringEmpty } from "../../services/StringService";
import { showError, showToast } from "../../components/ATPDialogs";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import {
  getActivityDate,
  addStudentsToActivityDate,
  getActivityDateStudents,
  updateSADStudentModify,
  updateSADTeacherModify,
  updateADStudentModify,
  updateADTeacherModify,
  removeSAD,
  addStudentListToActivityDate,
  createADUserList,
  deleteADAttendees,
} from "../../services/ActivityService";
import {
  getTeacherUserLists,
  getSchoolStudents,
  getUserPriority,
} from "../../services/UserService";
import { hasError, getError } from "../../services/ServiceHelper";

import "../../ResponsiveTable.css";

const ViewAttendance = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const { activityDateEid } = useParams();

  const [_jwt] = useJwtStorage();

  const [_activityDetails, setActivityDetails] = useState({});
  const [_activityStudents, setActivityStudents] = useState([]);
  const [_userListOptions, setUserListOptions] = useState([]);
  const [_userListsMap, setUserListsMap] = useState({});
  const [_students, setStudents] = useState([]);

  const [_dialogDetailsOpen, setDialogDetailsOpen] = React.useState(false);
  const [_dialogStudentsOpen, setDialogStudentsOpen] = React.useState(false);
  const [_dialogStudentListsOpen, setDialogStudentListsOpen] =
    React.useState(false);
  const [_dialogStudentResultOpen, setDialogStudenResultOpen] =
    React.useState(false);

  const [, setActivityDate] = useState({});

  const [_selectedAttendee, setSelectedAttendee] = useState({});
  const navigate = useNavigate();

  const [showProgress, setShowProgress] = useState(false);

  const [_addSuccesses, setAddSuccesses] = useState([]);
  const [_addFails, setAddFails] = useState([]);

  useEffect(() => {
    initActivities();
    initUserLists();
    initActivityDateStudents();
    initStudents();
  }, []);

  const initActivityDateStudents = () => {
    getActivityDateStudents(_school, _jwt, activityDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to get Activity Date Students: ",
            getError(results),
          );
          return;
        }

        setActivityStudents(results.data.attendees);
        setActivityDetails(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initStudents = () => {
    getSchoolStudents(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Students: ", getError(results));
          return;
        }

        const labeledStudents = [];
        for (const student of results.data) {
          let label = `${student.last_name}, ${student.first_name}`;

          if (!isEmpty(student.mi)) {
            label += ` ${student.mi}.`;
          }

          label += ` (${student.grade})`;
          labeledStudents.push({
            label: label,
            value: student.eid,
          });
        }

        setStudents(labeledStudents);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initUserLists = () => {
    getTeacherUserLists(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get User Lists: ", getError(results));
          return;
        }

        const labeledLists = [];
        const map = {};
        for (const studentList of results.data) {
          labeledLists.push({
            label: studentList.name,
            value: studentList.id,
          });
          const key = `u${studentList.id}`;
          map[key] = studentList.studentCount;
        }
        setUserListsMap(map);
        setUserListOptions(labeledLists);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {});
  };

  const initActivities = () => {
    setShowProgress(true);

    const promises = [getActivityDate(_school, _jwt, activityDateEid)];

    Promise.all(promises)
      .then((allResults) => {
        let results = allResults[0];
        if (hasError(results) === true) {
          showToast("E", "Unable to get Activities: ", getError(results));
          return;
        }

        setActivityDate(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const gotoAddStudentList = () => {
    setDialogStudentListsOpen(true);
  };

  const gotoAddStudent = () => {
    setDialogStudentsOpen(true);
  };

  const gotoCreateList = () => {
    let name = window.prompt("Please enter the new Student List name.");

    if (isStringEmpty(name)) {
      showError(
        "Unable to Create Student List",
        "Please enter Student List name.",
      );
      return;
    }

    setShowProgress(true);
    createADUserList(_school, _jwt, activityDateEid, name)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to create activity date user list: ",
            getError(results),
          );
          return;
        }
        showToast("S", "User List Created");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const gotoTakeAttendance = () => {
    navigate(`/teacher/ad/${activityDateEid}/attendance/take`);
  };

  const handleChangeListAction = (event) => {
    switch (event.value) {
      case "TA":
        return gotoTakeAttendance();
      case "CS":
        return gotoCreateList();
      case "AS":
        return gotoAddStudent();
      case "ASS":
        return gotoAddStudentList();
      default:
        return null;
    }
  };

  const handleStudentsClose = () => {
    setDialogStudentsOpen(false);
  };

  const handleStudentResultClose = () => {
    setDialogStudenResultOpen(false);
  };

  const handleStudentListClose = () => {
    setDialogStudentListsOpen(false);
  };

  const handleDetailsClose = () => {
    setDialogDetailsOpen(false);
  };

  const handleStudentListOK = (selectedList) => {
    setDialogStudentListsOpen(false);

    const key = `u${selectedList.value}`;
    const currentCount = _activityStudents.length;
    const userListCount = _userListsMap[key] ? _userListsMap[key] : 0;
    const proposedCount = currentCount + userListCount;
    const maxCount = _activityDetails.maxAttendance;

    if (proposedCount > maxCount) {
      if (
        !window.confirm(
          `WARNING: If you add this list of ${userListCount} student(s), you will exceed the activity's max attendance of ${maxCount} student(s).\nClick OK to continue adding students, or cancel to stop.`,
        )
      ) {
        return;
      }
    }

    setShowProgress(true);
    addStudentListToActivityDate(
      _school,
      _jwt,
      activityDateEid,
      selectedList.value,
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Add Student List: ", getError(results));
          return;
        }

        setAddSuccesses(results.data.successes);
        setAddFails(results.data.fails);
        setDialogStudenResultOpen(true);

        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleStudentsOK = (selectedStudents) => {
    setDialogStudentsOpen(false);

    if (selectedStudents.length === 0) {
      return;
    }

    const currentCount = _activityStudents.length;
    const proposedCount = currentCount + selectedStudents.length;
    const maxCount = _activityDetails.maxAttendance;

    if (proposedCount > maxCount) {
      if (
        !window.confirm(
          `WARNING: If you add this set of ${selectedStudents.length} student(s), you will exceed the activity's max attendance of ${maxCount} student(s).\nClick OK to continue adding students, or cancel to stop.`,
        )
      ) {
        return;
      }
    }

    // collect IDs from raw values
    const studentEids = [];
    for (const student of selectedStudents) {
      studentEids.push(student.value);
    }

    setShowProgress(true);
    addStudentsToActivityDate(_school, _jwt, activityDateEid, studentEids)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Add Students: ", getError(results));
          return;
        }

        setAddSuccesses(results.data.successes);
        setAddFails(results.data.fails);
        setDialogStudenResultOpen(true);

        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleChangeStudentModify = (event, sadEid) => {
    setShowProgress(true);
    updateSADStudentModify(_school, _jwt, sadEid, event.target.checked)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to update student modify: ",
            getError(results),
          );
          return;
        }
        showToast("S", "Student Modify Updated");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const handleChangeTeacherModify = (event, sadEid) => {
    setShowProgress(true);
    updateSADTeacherModify(_school, _jwt, sadEid, event.target.checked)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to update teacher modify: ",
            getError(results),
          );
          return;
        }
        showToast("S", "Teacher Modify Updated");
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const handleClickStudentRemove = (event, student) => {
    if (!window.confirm("Click OK to remove student.")) {
      return;
    }

    setShowProgress(true);
    removeSAD(_school, _jwt, student.studentActivityDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to remove student: ", getError(results));
          return;
        }
        showToast("S", "Student Removed");
        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const handleChangeAllStudentModify = (event) => {
    // mark all as checked or unchecked

    setShowProgress(true);
    updateADStudentModify(_school, _jwt, activityDateEid, event.target.checked)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to update activity date student modify: ",
            getError(results),
          );
          return;
        }
        showToast("S", "All Student Modify Updated");

        for (let student of _activityStudents) {
          student.modify = event.target.checked ? 1 : 0;
        }

        // force clear and refresh; checkboxes are weird
        forceRefreshStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const forceRefreshStudents = () => {
    const activityStudents = _activityStudents;
    setActivityStudents([]);
    setTimeout(function () {
      setActivityStudents(activityStudents);
    }, 1000);
  };

  const handleChangeAllTeacherModify = (event) => {
    const checked = event.target.checked;
    // mark all as checked or unchecked

    setShowProgress(true);
    updateADTeacherModify(_school, _jwt, activityDateEid, event.target.checked)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to update activity date teacher modify: ",
            getError(results),
          );
          return;
        }
        showToast("S", "All Teacher Modify Updated");

        let value = null;
        if (checked) value = 1234;
        for (let student of _activityStudents) {
          student.lockTeacherId = value;
        }

        // force clear and refresh; checkboxes are weird
        forceRefreshStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress();
      });
  };

  const handleClickDetails = (event, student) => {
    setSelectedAttendee(student);
    setDialogDetailsOpen(true);
    console.log(student);
  };

  const handleClickStudentRemoveAll = () => {
    if (
      !window.confirm(
        "Click OK to remove ALL students from this activity date.",
      )
    ) {
      return;
    }

    setShowProgress(true);
    deleteADAttendees(_school, _jwt, activityDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to Remove All Students: ", getError(results));
          return;
        }
        initActivityDateStudents();
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  return (
    <>
      <DrawerAppBar />
      <SearchBar />

      <Container sx={{ mt: 1 }}>
        <Title text="View Attendance" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Activity Details
          </AccordionSummary>
          <AccordionDetails>
            <ActivityDetails
              school={_school}
              activityDetails={_activityDetails}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Student Roster
          </AccordionSummary>
          <AccordionDetails>
            <Alert severity="info" sx={{ mt: 1 }}>
              You can now check and uncheck the Student Can Modify and Other
              Teacher Can Modify checkboxes. "ANT" stands for "Attendance not
              Taken."
            </Alert>

            <div style={{ marginTop: "1em", marginBottom: "1em" }}>
              <Menu
                menuButton={
                  <Button variant="outlined" sx={{ mb: 1 }}>
                    Actions
                  </Button>
                }
                transition
              >
                <MenuItem
                  value="AS"
                  onClick={(event) => handleChangeListAction(event)}
                >
                  Add Student(s)
                </MenuItem>
                <MenuItem
                  value="ASS"
                  onClick={(event) => handleChangeListAction(event)}
                >
                  Add Student List
                </MenuItem>
                <MenuItem
                  value="TA"
                  onClick={(event) => handleChangeListAction(event)}
                >
                  Take Attendance
                </MenuItem>
                <MenuItem
                  value="CS"
                  onClick={(event) => handleChangeListAction(event)}
                >
                  Create Student List
                </MenuItem>
              </Menu>
            </div>

            <Grid container spacing={0} sx={{ mt: -3 }}>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(event) => handleChangeAllStudentModify(event)}
                    />
                  }
                  label="Check/Uncheck All Student Checkboxes Below"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(event) => handleChangeAllTeacherModify(event)}
                    />
                  }
                  label="Check/Uncheck All Teacher Checkboxes Below"
                />
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "right" }}>
                {getUserPriority(_jwt) === 800 && (
                  <Button
                    onClick={() => handleClickStudentRemoveAll()}
                    sx={{ ml: 1 }}
                    variant="outlined"
                  >
                    REMOVE ALL STUDENTS
                  </Button>
                )}
              </Grid>
            </Grid>

            <Table>
              <Thead>
                <Tr>
                  <Th>Student Name</Th>
                  <Th>Status</Th>
                  <Th>
                    Student can Modify?{" "}
                    <InfoIcon
                      text={
                        "If the box is NOT checked, the student CANNOT change this activity."
                      }
                    />
                  </Th>
                  <Th>
                    Other Teacher can Modify?{" "}
                    <InfoIcon
                      text={
                        "If the box is NOT checked, a teacher CANNOT steal this student."
                      }
                    />
                  </Th>
                  <Th>Actions</Th>
                  <Th>Details</Th>
                </Tr>
              </Thead>
              <Tbody>
                {_activityStudents.map((student) => (
                  <Tr key={student.user_eid}>
                    <Td>
                      <span style={{ fontWeight: 600 }}>
                        {student.last_name}, {student.first_name}
                        {isEmpty(student.mi) === false && <> {student.mi}.</>}
                      </span>
                    </Td>
                    <Td>
                      <AttendanceStatus
                        activityDetails={_activityDetails}
                        student={student}
                      />
                    </Td>
                    <Td>
                      <div style={{ textAlign: "center" }}>
                        <Checkbox
                          sx={{ pt: 0, textAlign: "center" }}
                          defaultChecked={student.modify === 1}
                          className="chkStudent"
                          onChange={(event) =>
                            handleChangeStudentModify(
                              event,
                              student.studentActivityDateEid,
                            )
                          }
                        />
                      </div>
                    </Td>
                    <Td>
                      <div style={{ textAlign: "center" }}>
                        <Checkbox
                          sx={{ pt: 0, textAlign: "center" }}
                          defaultChecked={student.lockTeacherId == null}
                          className="chkTeacher"
                          onChange={(event) =>
                            handleChangeTeacherModify(
                              event,
                              student.studentActivityDateEid,
                            )
                          }
                        />
                      </div>
                    </Td>
                    <Td>
                      <Button
                        key={`btnRemove${student.studentActivityDateEid}`}
                        onClick={(event) =>
                          handleClickStudentRemove(event, student)
                        }
                        sx={{ ml: 1 }}
                        variant="outlined"
                      >
                        REMOVE
                      </Button>
                    </Td>
                    <Td>
                      <IconButton
                        variant="contained"
                        color="primary"
                        onClick={(event) => handleClickDetails(event, student)}
                      >
                        <MoreHorizIcon />
                      </IconButton>
                    </Td>
                  </Tr>
                ))}
                {_activityStudents.length === 0 && (
                  <Tr>
                    <Td colSpan={6}>-- NO ATTENDEES --</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Container>

      <SelectStudentsDialog
        open={_dialogStudentsOpen}
        onClose={handleStudentsClose}
        onOK={handleStudentsOK}
        students={_students}
      />

      <SelectStudentListsDialog
        open={_dialogStudentListsOpen}
        onClose={handleStudentListClose}
        onOK={handleStudentListOK}
        studentLists={_userListOptions}
      />

      <AttendeeDetailsDialog
        open={_dialogDetailsOpen}
        onClose={handleDetailsClose}
        attendee={_selectedAttendee}
      />

      <AddStudentResultDialog
        open={_dialogStudentResultOpen}
        successes={_addSuccesses}
        fails={_addFails}
        onClose={handleStudentResultClose}
      />
    </>
  );
};

export default ViewAttendance;
